import { useIntl } from 'react-intl';

import { type CohortProfileView } from '@verantos-dev/data-access-cohorts';
import { ApiWorkflowDialogMessages } from '@verantos-dev/shared-components';

export const useDeleteCohortModalStrings = (cohort?: CohortProfileView) => {
  const intl = useIntl();
  const contentMessages = {
    title: intl.formatMessage({ id: 'cohortsList.deleteCohortModal.title' }),
    confirmTitle: intl.formatMessage({ id: 'projectsList.deleteProjectModal.confirmTitle' }),
    description: intl.formatMessage(
      { id: 'cohortsList.deleteCohortModal.description' },
      { cohortName: <b>{cohort?.cohortName || 'project'}</b> }
    ),
    actionUndone: intl.formatMessage({ id: 'cohortsList.deleteCohortModal.actionUndone' }),
    disableDeleteStatus: intl.formatMessage(
      { id: 'cohortsList.deleteCohortModal.disableDeleteStatus' },
      { status: <b>{cohort?.latestStatus || 'Unknown'}</b> }
    ),
    inUseTitle: intl.formatMessage({ id: 'cohortsList.deleteCohortModal.inUseTitle' }),
    inUseDescription: intl.formatMessage({
      id: 'cohortsList.deleteCohortModal.inUseDescription',
    }),
  };

  const dialogMessages: ApiWorkflowDialogMessages = {
    loadingCancelButtonText: intl.formatMessage({
      id: 'cohortsList.deleteCohortModal.cancelButton',
    }),
    loadingSaveButtonText: intl.formatMessage({
      id: 'cohortsList.deleteCohortModal.deleteButton',
    }),
    entryCancelButtonText: intl.formatMessage({
      id: 'cohortsList.deleteCohortModal.cancelButton',
    }),
    entrySaveButtonText: intl.formatMessage({ id: 'cohortsList.deleteCohortModal.deleteButton' }),
    submittingCancelButtonText: intl.formatMessage({
      id: 'cohortsList.deleteCohortModal.cancelButton',
    }),
    submittingSaveButtonText: intl.formatMessage({
      id: 'cohortsList.deleteCohortModal.submitting',
    }),
    successCloseButtonText: intl.formatMessage({
      id: 'cohortsList.deleteCohortModal.closeButton',
    }),
    submittingErrorTitle: intl.formatMessage({
      id: 'cohortsList.deleteCohortModal.submittingError',
    }),
    successTitle: intl.formatMessage({ id: 'cohortsList.deleteCohortModal.success.title' }),
    successText: intl.formatMessage(
      { id: 'cohortsList.deleteCohortModal.success.text' },
      { cohortName: cohort?.cohortName || 'Cohort' }
    ),
  };

  return {
    dialogMessages,
    contentMessages,
  };
};
